import { createSelector } from 'reselect';
import { planSelector } from 'domain/Options/selectors';

const parameterSelector = (parameter) => createSelector(
  planSelector,
  (plan) => plan.get(parameter)
);

export default parameterSelector;
